<template>
  <div class="retinuePage">
    <van-search
      v-model="searchKeyword"
      class="searchBox"
      id="searchHeight"
      placeholder="请输入搜索关键词"
      @input="onSearch"
      show-action
      shape="round"
    >
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>
    <div class="list-content" id="list-content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
      >
        <van-checkbox-group v-model="result">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in retinueMainList"
              clickable
              :key="item.id"
              :title="`${item.realName}`"
              @click="toggle(index, item)"
              class="item"
            >
              <van-checkbox
                :name="item.realName"
                ref="checkboxes"
                slot="right-icon"
              />
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </van-list>
    </div>
    <div class="roleBtn clearfix">
      <a href="javascript:void(0);" class="fl" @click="closeRetinuePicker"
        >取消</a
      >
      <a href="javascript:void(0);" class="fl" @click="saveRetinue">确认</a>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
export default {
  name: "selectPeople",
  data() {
    return {
      searchName: "",
      searchKeyword: "", //搜索的姓名人员
      total: "", //统计计算
      retinueMainList: [],
      retinueList: [], //随行人员列表
      result: [], //选择的随行人员列表
      retinuedata: [], //选中的随行人员列表
      cloneRetinuedata: [],
      sourceData: [], //父级组件传递值
      retinueIdList: [],
      retinueNameList: "",
      page: 0,
      pageSize: 99,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      clientType: "", //手机类型
    };
  },
  props: {
    retinueUids: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.getRetinueList();
  },
  methods: {
    toggle(index, item) {
      this.$refs.checkboxes[index].toggle();
      this.retinuedata.push(item);
      this.unique(this.retinuedata);
    },
    onSearch() {
      let _this = this;
      _this.searchName = _this.searchKeyword;
      _this.reloadPage();
    },
    onCancel() {
      let _this = this;
      this.searchName = "";
      _this.reloadPage();
    },
    getRetinueList() {
      let _this = this;
      if (
        _this.page != 0 &&
        _this.page * _this.pageSize >= parseInt(_this.total)
      ) {
        return;
      }
      _this.page += 1;
      _this.$api.baseCommon.baseMsg.dictBox
        .staffPageList(_this.page, _this.pageSize, {
          realName: _this.searchName,
          enable: true,
        })
        .then((res) => {
          if (res.code == "1") {
            _this.total = parseInt(res.data.total);
            _this.retinueList = res.data.list;
            _this.viewLists();
            // 加载状态结束
            this.loading = false;
            if (_this.page * _this.pageSize >= _this.total) {
              _this.finished = true;
              console.log("加载完成");
            } else {
              _this.getRetinueList();
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },
    viewLists() {
      this.retinueMainList = this.retinueMainList.concat(this.retinueList);
      if (this.retinueMainList.length == this.total) {
        for (let i = 0; i < this.retinueUids.length; i++) {
          for (let j = 0; j < this.retinueMainList.length; j++) {
            if (this.retinueUids[i] == this.retinueMainList[j].id) {
              this.result.push(this.retinueMainList[j].realName);
              this.retinuedata.push(this.retinueMainList[j]);
              this.unique(this.retinuedata);
            }
          }
        }
      }
    },
    closeRetinuePicker() {
      this.retinuedata = [];
      this.$emit("setReview", "","");
    },
    saveRetinue() {
      let _this = this;
      let delIdArr = [];
      console.log(_this.retinuedata, "retinuedata");
      console.log(_this.retinueUids, "retinueUids");
      for (let item of _this.retinueUids) {
        let _index = _this.retinuedata.findIndex((v) => v.id == item);
        if (_index < 0) {
           console.log(item)
           delIdArr.push(item)
        }
      }
      _this.$emit("setReview", _this.retinuedata, delIdArr);
      _this.retinuedata = [];
      delIdArr = [];
    },
    unique(dataArray) {
      //数组去重
      let _this = this;
      let removeIndex = [];
      dataArray.forEach((item1, index1) => {
        const exist = dataArray.some(
          (item2, index2) => item1.id === item2.id && index1 !== index2
        );
        if (exist) {
          removeIndex.unshift(index1);
        }
      });
      newApi.each(removeIndex, (index) => {
        delete dataArray[index];
      });
      _this.retinuedata = _this.retinuedata.filter(function () {
        return true;
      });
    },
    reloadPage() {
      this.page = 0;
      this.retinueMainList = [];
      this.loading = false; //是否处于加载状态
      this.finished = false; //是否已加载完所有数据
      setTimeout(() => {
        this.getRetinueList();
      }, 300);
    },
  },
  watch: {
    retinueUids: {
      handler: function (arrIds) {
        this.result = [];
        this.retinuedata = [];
        for (let i = 0; i < arrIds.length; i++) {
          for (let j = 0; j < this.retinueMainList.length; j++) {
            if (arrIds[i] == this.retinueMainList[j].id) {
              this.result.push(this.retinueMainList[j].realName);
              this.retinuedata.push(this.retinueMainList[j]);
              this.unique(this.retinuedata);
            }
          }
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less" >
.retinuePage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .searchBox {
    padding: 0 8px;
    margin-bottom: 10px;
  }
  .list-content {
    height: calc(100% - 45px);
    overflow: scroll;
    .list-item {
      .item {
        height: 45px;
      }
    }
  }
  .roleBtn {
    position: fixed;
    width: 100%;
    font-size: 15px;
    text-align: center;
    color: #333;
    height: 45px;
    bottom: 0;
    background-color: #fff;
    z-index: 10001 !important;
    border-top: 1px solid #f6f6f6;
    a:first-child {
      color: rgb(235, 199, 155);
      border-right: 1px solid #f6f6f6;
    }
    a {
      display: inline-block;
      width: 50%;
      height: 100%;
      line-height: 45px;
      color: #07c160;
      font-size: 14px;
      box-sizing: border-box;
    }
  }
}
</style>